import { Component }       from '@angular/core';
import { Params, Router }  from '@angular/router';
import { Location }        from '@angular/common';

import { CallService } from '../services/calls/call.service';
import { Call } from '../classes/call';
import { StatusCallsComponent } from './statusCalls.component';
import { ReportService } from '../services/reports/report.service';
import { ProviderService } from '../services/providers/provider.service';



import * as _ from 'lodash';

@Component({
  moduleId: module.id,
  selector: 'diagnosis-calls',
  templateUrl: 'diagnosisCalls.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class DiagnosisCallsComponent extends StatusCallsComponent{


  constructor(protected callService: CallService,
              protected location: Location,
              protected router: Router,
              protected infoService: ReportService,
              protected providerService:ProviderService) {
                  super(callService,location,router,infoService,providerService);
    }

    infoName='diagnosis'
      
}


// WEBPACK FOOTER //
// ./src/app/calls/diagnosisCalls.component.ts